var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 20 20","fill":"none"}},[_c('path',{attrs:{"d":"M15.5 11.6667L10.5 16.6667L5.5 11.6667M10.5 15.8334V3.33337","stroke":_vm.stroke,"stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }